var _defineProperty = require("/Users/enguerrand/Dev/Sandblock/surprise-chain-explorer/client/node_modules/@babel/runtime/helpers/defineProperty");

var _possibleConstructorReturn = require("/Users/enguerrand/Dev/Sandblock/surprise-chain-explorer/client/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/enguerrand/Dev/Sandblock/surprise-chain-explorer/client/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/enguerrand/Dev/Sandblock/surprise-chain-explorer/client/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/Users/enguerrand/Dev/Sandblock/surprise-chain-explorer/client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/enguerrand/Dev/Sandblock/surprise-chain-explorer/client/node_modules/@babel/runtime/helpers/createClass");

//let privTypeMap = undefined
var _require = require('./types'),
    Types = _require.Types;

var Reflection = require("./reflect");

var privTypeMap = Symbol("privateTypeMap");
var aminoTypes = new Array();

var isExisted = function isExisted(name) {
  return aminoTypes.includes(name);
};

var defaultTypes = [Types.Struct, Types.ByteSlice, Types.Interface, Types.ArrayStruct, Types.ArrayInterface]; //list of type needs to init default value before decoding

var BaseAminoType =
/*#__PURE__*/
function () {
  "use strict";

  function BaseAminoType() {
    _classCallCheck(this, BaseAminoType);

    this[privTypeMap] = new Map();
  }

  _createClass(BaseAminoType, [{
    key: "set",
    value: function set(name, type) {
      if (this[privTypeMap].has(name)) throw new RangeError("property '".concat(name, "' existed"));
      this[privTypeMap].set(name, type);
    }
  }, {
    key: "lookup",
    value: function lookup(name) {
      return this[privTypeMap].get(name);
    }
  }]);

  return BaseAminoType;
}();

var create = function create(className, properties) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Types.Struct;

  if (!properties) {
    throw new Error("Type List can not be empty");
  }

  if (!properties.length) {
    throw new Error("Need to provide TypeList");
  }
  /*AminoType*/


  var objAmino = _defineProperty({}, className,
  /*#__PURE__*/
  function (_BaseAminoType) {
    "use strict";

    _inherits(_class, _BaseAminoType);

    function _class() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _classCallCheck(this, _class);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this));
      var idx = 0;
      properties.forEach(function (prop) {
        Reflect.ownKeys(prop).forEach(function (key) {
          if (key == 'name') {
            // this.idx = idx;
            _this[prop[key]] = args[idx++];
          } else if (key == 'type') {
            _this.set(prop['name'], prop['type']);

            if (defaultTypes.includes(prop['type'])) {
              //action for decoding: set up the default value for Type.Struct field
              if (_this[prop['name']]) {
                // let defaultAminotye = Object.assign({}, this[prop['name']])                                 
                // Object.setPrototypeOf(defaultAminotye, objAmino[className].prototype)
                // objAmino[className].prototype.defaultMap.set(prop['name'], defaultAminotye)
                objAmino[className].prototype.defaultMap.set(prop['name'], _this[prop['name']]);
              }
            }
          }
        });
      });

      if (args.length == 0) {
        _this[privTypeMap].forEach(function (value, key, map) {
          if (defaultTypes.includes(value)) {
            _this[key] = objAmino[className].prototype.defaultMap.get(key);
          }
          /*else if (value == Types.ArrayStruct || value == Types.ArrayInterface) {
                                     console.log("default for array struct=",objAmino[className].prototype.defaultMap.get(key))
                                     this[key] = []
                                 }*/

        });
      }

      return _this;
    }

    _createClass(_class, [{
      key: "typeName",
      value: function typeName() {
        return className;
      }
    }, {
      key: "baseName",
      value: function baseName() {
        return 'AminoType';
      }
    }, {
      key: "JsObject",
      value: function JsObject() {
        var _this2 = this;

        var obj = {};
        Reflect.ownKeys(this).forEach(function (key) {
          var typeLookup = _this2.lookup(key);

          if (typeof key != 'symbol') {
            if (typeLookup == Types.ArrayStruct || typeLookup == Types.ArrayInterface) {
              obj[key] = [];
              var values = _this2[key];
              values.forEach(function (value, idx) {
                if (typeof value.JsObject == 'function') {
                  //check if this property has recursive JsObject                                   
                  obj[key].push(value.JsObject());
                } else {
                  console.log("not jsObject");
                  obj[key].push(value);
                }
              });
            } else {
              if (typeof _this2[key].JsObject !== 'function') {
                //check if this property has recursive JsObject
                obj[key] = _this2[key];
              } else {
                obj[key] = _this2[key].JsObject();
              }
            }
          }
        });
        return obj;
      }
    }, {
      key: "info",
      get: function get() {
        return objAmino[className].prototype.privateInfo;
      },
      set: function set(_info) {
        objAmino[className].prototype.privateInfo = _info;
      }
      /*  get index() {
          return this.idx
      }
           set index(_idx) {
          console.log('set index=',_idx)
          this.idx = _idx
      } */

    }, {
      key: "type",
      get: function get() {
        return objAmino[className].prototype.privateType;
      }
    }]);

    return _class;
  }(BaseAminoType));

  aminoTypes.push(className);
  objAmino[className].prototype.defaultMap = new Map();
  objAmino[className].prototype.privateInfo = null;
  objAmino[className].prototype.privateType = type; //return AminoType;

  return objAmino[className];
};

module.exports = {
  create: create,
  isExisted: isExisted
};

if (require.main === module) {
  var A = create('TestAmino', [{
    name: "a",
    type: Types.Int32
  }, {
    name: "b",
    type: Types.Int64
  }]);
  var B = create('B', [{
    name: "a",
    type: Types.Int32
  }, {
    name: "b",
    type: Types.Int16
  }]);
  var aObj = new A(100, 200);
  var obj = new B(100, 200);
  console.log(Reflection.typeOf(obj));
}